import { RouteConfig } from 'vue-router';
import MswDownloadCenter from './msw-download-center.vue';

const mswDownloadCenterPage: RouteConfig = {
  path: 'downloadcenter',
  component: MswDownloadCenter,
};

export function getDefaultParams() {
  return {};
}

export default mswDownloadCenterPage;
